import { render, staticRenderFns } from "./ChartFour.vue?vue&type=template&id=3fa80845&scoped=true"
import script from "./ChartFour.vue?vue&type=script&lang=js"
export * from "./ChartFour.vue?vue&type=script&lang=js"
import style0 from "./ChartFour.vue?vue&type=style&index=0&id=3fa80845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa80845",
  null
  
)

export default component.exports